import Text from "../_widgets/Text/Text";
import Input from "../_widgets/Input/Input";
import Button from "../_widgets/Button/Button";
import NavBar from "../_widgets/NavBar/NavBar";
import { Table } from "react-bootstrap";
import BasicModal from "../_widgets/Modal/BasicModal";
import { Row, Col, Form } from "react-bootstrap";
import CustomPagination from "../_widgets/Pagination/Pagination";
import AnimatedPage from "../AnimatedPage/AnimatedPage";
import Dropdown from "../_widgets/Dropdown/Dropdown";
import MainLoader from "../_widgets/Loader/MainLoader";
import CustomTooltip from "../_widgets/Tooltip/CustomTooltip";
import IconResource from "../../Wrapper/IconResource/IconResource";
import { warn } from "../../Wrapper/toast/toast";
import * as stringConstants from "../../Constants/stringConstants";
import {
  createWhatsAppLink,
  getActiveInactiveOptions,
  getDepartmentOptions,
  getGenderOptions,
  getRegularNonRegularOptions,
  getUserRoleName,
  getUserRoleOptions,
  removeInActive,
} from "../../Services/common";
import { capitalizeFirstLetter, isNullOrEmpty } from "../../Utils/stringUtils";
import { getColorFromStatus } from "../../Utils/appUtils";
import MultiSelectDropdown from "../_widgets/MultiSelect/MultiSelectDropdown";
import { DOCTOR } from "../../Constants/appConstants";
import ImageResource from "../../Wrapper/ImageResource/ImageResource";

const DigitalProUI = ({
  modalShow,
  setModalShow,
  handleClose,
  searchQuery,
  clearFilter,
  setSearchQuery,
  onPageChange,
  loading,
  buttonLoading,
  usersList,
  userData,
  setUserData,
  upsertUser,
  handleEditClick,
  handleStatusChange,
  selectedRoleOptions,
  setSelectedRoleOptions,
  selectedStatusOptions,
  setSelectedStatusOptions,
  getUsersList,
}) => {
  const getPasswordLabel = () => {
    const label =
      userData.action === "Add" ? (
        "Password"
      ) : (
        <div className="d-flex h-100  align-items-center gap-1 justify-content-center">
          Password
          <CustomTooltip text={stringConstants.PASSWORD_FIELD_INFO} placement={"left"}>
            <IconResource type="info" size={18} color="var(--primary)" className="hand-hover" />
          </CustomTooltip>
        </div>
      );

    return label;
  };

  return (
    <AnimatedPage>
      <NavBar
        button="Add Digital PRO"
        buttonIcon={"adduser"}
        heading={`User List`}
        onClick={() => {
          document.body.classList.toggle("side_active");
          document.body.classList.toggle("side_active_mb");
        }}
        setModalShow={setModalShow}
        Icon="menu"
      />

      <BasicModal
        show={modalShow}
        size="lg"
        setModalShow={setModalShow}
        handleClose={handleClose}
        heading={`${userData.action} User`}
        footer
        button2Text={"Save"}
        button2Click={upsertUser}
        loading={buttonLoading}
      >
        <div className="patients_ui">
          <Row>
            <Col xl={12}>
              <div className="white_card text-start">
                <Row className="mb-3">
                  <Col sm={6} md={4} lg={4}>
                    <Input
                      placeholder="Enter User Name"
                      type="text"
                      label="Name"
                      style={{ textTransform: "capitalize" }}
                      isRequired
                      value={userData.name}
                      onChange={(e) => {
                        if (e.target.value.length <= 50) {
                          setUserData({ ...userData, name: e.target.value });
                        } else {
                          warn(stringConstants.maximumLengthAllowed(50));
                        }
                      }}
                    />
                  </Col>

                  <Col sm={6} md={4} lg={4}>
                    <Input
                      placeholder="Enter User Mobile Number"
                      type="number"
                      label="Mobile Number"
                      value={userData.mno}
                      onChange={(e) => {
                        if (e.target.value.length <= 14) {
                          setUserData({ ...userData, mno: e.target.value });
                        } else {
                          warn(stringConstants.maximumLengthAllowed(14));
                        }
                      }}
                    />
                  </Col>

                  <Col sm={6} md={4} lg={4}>
                    <Input
                      placeholder="Enter User Email"
                      type="email"
                      label="Email"
                      value={userData.email}
                      autoComplete="off"
                      name="disable-autofill-email"
                      onChange={(e) => {
                        if (e.target.value.length <= 30) {
                          setUserData({ ...userData, email: e.target.value });
                        } else {
                          warn(stringConstants.maximumLengthAllowed(30));
                        }
                      }}
                    />
                  </Col>
                  <Col sm={6} md={4} lg={4}>
                    <Input
                      placeholder="Enter User Password"
                      type="password"
                      label={getPasswordLabel()}
                      value={userData.password}
                      autoComplete="off"
                      name="disable-autofill-pass"
                      onChange={(e) => {
                        if (e.target.value.length <= 12) {
                          setUserData({
                            ...userData,
                            password: e.target.value,
                          });
                        } else {
                          warn(stringConstants.maximumLengthAllowed(12));
                        }
                      }}
                    />
                  </Col>

                  <Col sm={6} md={4} lg={4}>
                    <Dropdown
                      label="Gender"
                      placeholder="Gender"
                      name={userData.gender}
                      options={getGenderOptions()}
                      onChange={(value) => setUserData({ ...userData, gender: value })}
                    />
                  </Col>

                  <Col sm={6} md={4} lg={3}>
                    <Dropdown
                      label="Status"
                      placeholder="Status"
                      isRequired
                      name={userData.status}
                      options={getActiveInactiveOptions()}
                      onChange={(value) => setUserData({ ...userData, status: value })}
                    />
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </div>
      </BasicModal>

      <div className="patient_list white_card">
        <div className="top_bar">
          <Text type="h2" text="" />

          <div className="d-flex align-items-center gap-3">
            <div className="d-flex align-items-center gap-2">
              <div className="bg_grey d-flex flex-column align-items-center justify-content-center position-relative px-3 py-1">
                {selectedStatusOptions.length > 0 ? (
                  <div className="round-notification">{selectedStatusOptions.length}</div>
                ) : (
                  ""
                )}
                <MultiSelectDropdown
                  items={getActiveInactiveOptions()}
                  name={
                    <div className="d-flex align-items-center gap-1">
                      <IconResource type={"filter"} size={12} color={"var(--primary)"} />
                      <small
                        style={{
                          fontSize: "12px",
                          fontWeight: "bold",
                          color: "var(--primary)",
                          cursor: "pointer",
                        }}
                        className=""
                      >
                        Status
                      </small>
                      {selectedStatusOptions.length > 0 ? (
                        <IconResource
                          type={"cross"}
                          size={12}
                          onClick={(e) => clearFilter(e, setSelectedStatusOptions)}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  }
                  selectedOptions={selectedStatusOptions}
                  onChange={(value) => setSelectedStatusOptions(value)}
                />
              </div>
            </div>
            <Row className="search_filter">
              <Col lg={12} md={8} sm={8} xs={8} className="ps-1">
                <div>
                  <Input
                    placeholder="Search"
                    id="searchInput"
                    suffixIcon="search"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    onClickIconSuff={() => getUsersList()}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        getUsersList();
                      }
                    }}
                    iconTooltip="Search"
                  />
                </div>
              </Col>
            </Row>
          </div>
        </div>

        <div className="custom_table position-relative">
          {loading ? (
            <MainLoader />
          ) : usersList?.data?.length > 0 ? (
            <>
              <div>
                <Table responsive hover>
                  <thead>
                    <tr>
                      <th style={{ width: "25%" }}>Name</th>
                      <th>Gender</th>
                      <th>Contact</th>
                      <th>Department</th>
                      <th>Role</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>

                  <tbody>
                    {usersList?.data?.map((data) => {
                      return (
                        <tr key={data.id}>
                          <td className="word-break">{data.name}</td>
                          <td>{capitalizeFirstLetter(data.gender)}</td>
                          <td>
                            {!data.email && !data?.mno ? (
                              <div className="address">
                                <span>-</span>
                              </div>
                            ) : (
                              <div className="address">
                                <Text text={data.email} />
                                <div className="d-flex w-100 h-100 m-auto justify-content-center align-items-center gap-1">
                                  <Text type="small" text={data.mno} />
                                  {data.mno && (
                                    <span
                                      onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();

                                        if (data?.mno) {
                                          window.open(createWhatsAppLink(data?.mno, data?.name));
                                        }
                                      }}
                                    >
                                      <IconResource type="whatsapp" size={16} />
                                    </span>
                                  )}
                                </div>
                              </div>
                            )}
                          </td>

                          <td>
                            {isNullOrEmpty(data.department?.name) ? "-" : data.department?.name}
                          </td>
                          <td>{getUserRoleName(data.role)}</td>
                          <td>
                            <div className={`status status__${getColorFromStatus(data.status)}`}>
                              <Text text={capitalizeFirstLetter(data.status)} />
                            </div>
                          </td>
                          <td>
                            <div className="d-flex align-items-center gap-2 justify-content-center">
                              <CustomTooltip text="Edit" placement={"top"}>
                                <Button
                                  className="p-1 bg-transparent border-0"
                                  icon={<IconResource type="edit" color="var(--light-text)" />}
                                  onClick={() => handleEditClick(data)}
                                />
                              </CustomTooltip>
                              <CustomTooltip text="Change Status" placement="top">
                                <IconResource
                                  type={
                                    buttonLoading === "status-changing" + data.id
                                      ? "loader"
                                      : "exchange"
                                  }
                                  color="var(--primary)"
                                  onClick={() => handleStatusChange(data)}
                                />
                              </CustomTooltip>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>

              <CustomPagination
                activePage={usersList?.current_page}
                onPageChange={onPageChange}
                pageLength={usersList?.per_page}
                totalData={usersList?.total}
                lastPage={usersList?.last_page}
              />
            </>
          ) : (
            <>
              <Table responsive hover>
                <thead>
                  <tr>
                    <th>S.No.</th>
                    <th>Name</th>
                    <th>Gender</th>
                    <th>Email</th>
                    <th>Mobile</th>
                    <th>Department</th>
                    <th>Role</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody></tbody>
              </Table>
              <div className="no_data position-relative">
                <ImageResource type="noData" style={{ width: "300px" }} className="img-fluid" />
                <Text type="h2" text="There is no data to display." />
              </div>
            </>
          )}
        </div>
      </div>
    </AnimatedPage>
  );
};

export default DigitalProUI;
